var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section4"},[(!_vm.isMobile)?_c('img',{staticClass:"bg-img",attrs:{"src":require("./s4/map.jpg"),"alt":""}}):_c('Map',{attrs:{"bgSrc":_vm.bgSrc,"hand":_vm.hand}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }